/**
 * Feature roots used in the sidebar (single source of truth).
 */
export const SIDEBAR_FEATURE_BASE_PATHS = [
  '/lens-library',
  '/requirement-intake',
  '/test-automation',
  '/automation-scripts',
  '/',
  '/bug-report',
  '/brd-to-frd',
  
];

/**
 * If pathname is a feature route (with or without /projectId/:id), return the feature base and project id.
 * @param {string} pathname - e.g. location.pathname
 * @returns {{ featureBase: string | null, projectId: string | null }}
 */
export function parseFeatureProjectFromPath(pathname) {
  for (const base of SIDEBAR_FEATURE_BASE_PATHS) {
    if (pathname === base) {
      return { featureBase: base, projectId: null };
    }
    const prefix = `${base}/projectId/`;
    if (pathname.startsWith(prefix)) {
      const rest = pathname.slice(prefix.length);
      const projectId = rest.split('/').filter(Boolean)[0] ?? null;
      return { featureBase: base, projectId };
    }
  }
  return { featureBase: null, projectId: null };
}

/**
 * Build feature URL with projectId in path: /requirement-intake/projectId/7
 * @param {string} basePath - e.g. '/requirement-intake'
 * @param {string|number} projectId - project id (optional)
 * @returns {string} basePath or basePath/projectId/:id
 */
export const getFeaturePath = (basePath, projectId) =>
  projectId != null && String(projectId).trim() !== '' ? `${basePath}/projectId/${projectId}` : basePath;
